import React from 'react';
import ReactDOM from 'react-dom';
import "./index.css"
import AppRouter from './AppSplitter';
// import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
  document.getElementById('root')
);
